// extracted by mini-css-extract-plugin
export var details = "_m5-0";
export var inspectorPopover = "_m5-1";